<mat-card appearance="outlined" fxLayout="column">
  <mat-card-header>
    <mat-card-title>{{testbed?.identifier}}</mat-card-title>
  </mat-card-header>
  <mat-card-content>
    <mat-list>
      <mat-list-item>
        <p>
          <strong>Address</strong>
          {{testbed?.address}}
        </p>
      </mat-list-item>

      <mat-list-item>
        <p>
          <strong>Company</strong>
          {{testbed?.company?.companyName}}
        </p>
      </mat-list-item>

      <mat-list-item>
      </mat-list-item>

      <mat-list-item>
        <p>
          <strong>Storage</strong>
          {{testbed?.storage?.bucketId}}
        </p>
      </mat-list-item>
    </mat-list>
  </mat-card-content>
</mat-card>